import { render } from "./ViewDocumentsComponent.vue?vue&type=template&id=c5786488"
import script from "./ViewDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./ViewDocumentsComponent.vue?vue&type=script&lang=js"
script.render = render

export default script